/**
 * Created by Ning Jiang on 2022-01-13.
 */

export abstract class IdleAnimationController {

    constructor() {

    }

    public abstract start():void;

    public abstract stop():void;
}
